<div class="dsh-link-label" fxLayout="row" fxLayoutGap="8px">
    <div class="dsh-link-label-content"><ng-content></ng-content></div>
    <dsh-bi icon="arrow-right"></dsh-bi>
</div>
